export type TypeTrainerTypesKeys = 'senior' | 'normal'

const trainerTypes = {
  senior: 'Senior Personal Trainer',
  normal: 'Wellbeing Personal Trainer',
}

export default trainerTypes